import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EdpTermsConditionsModalComponent } from "./edp-terms-conditions-modal.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EdpToasterModule } from "@edp-components/edp-toaster/edp-toaster.module";

@NgModule({
    declarations: [EdpTermsConditionsModalComponent],
    imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, EdpToasterModule],
    exports: [EdpTermsConditionsModalComponent],
})
export class EdpTermsConditionsModalModule {}
